let sortKeyAsc = (array,key) =>{ //按照对象数组排序 正序
  return array.sort(function(a,b){
    var x = a[key];
    var y = b[key];
    return ((y>x)?-1:(y<x)?1:0)
  })
}

export {
  sortKeyAsc
}
